import { getProperty } from './UrlsAndEnvProperties';

class SystemProperty {

    public static hostName = window.location.hostname;

    static getProperty(propertyName: string) {
        if (SystemProperty.isProd()) {
            return getProperty(propertyName + '_prod');
        } else if (SystemProperty.isQa()) {
            return getProperty(propertyName + '_qa');
        } else if (SystemProperty.isDev()) {
            return getProperty(propertyName + '_dev');
        } else if (SystemProperty.isStage()) {
            return getProperty(propertyName + '_stage');
        } else if (SystemProperty.isPerformance()) {
            return getProperty(propertyName + '_performance');
        } else if (SystemProperty.isLocal()) {
            return getProperty(propertyName + '_local');
        } else {
            return '';
        }
    }
    
    static isProd() {
        return SystemProperty.hostName.includes('cam.hia');
    }

    static isStage() {
        return SystemProperty.hostName.includes('-staging') || SystemProperty.hostName.includes('-stage.hia');
    }

    static isPerformance() {
        // return SystemProperty.hostName.includes('-rkuwdjyj.apps.psr.aro.forgeapp');
        return SystemProperty.hostName.includes('-gbpjqpyj-performance-wraisjgf.apps.psr.aks.forgeapp');

    }

     static isDev() {
        return SystemProperty.hostName.includes('-dev');
    }

     static isQa() {
        return SystemProperty.hostName.includes('-qa');
    }

     static isLocal() {
        return SystemProperty.hostName.includes('local');
    }
}

export default SystemProperty;